import { useThemeData } from '@msrceng/theme';
import { APPBAR_HEIGHT } from './Appbar';
import { useAppBarColor } from './useAppBarBackgroundColor';
/** Style generator for the Appbar's usage of a Fluent CommandBar */
export const useAppbarCommandBarStyles = () => {
    const { theme } = useThemeData();
    const { palette } = theme;
    const { color } = useAppBarColor();
    return {
        primarySet: {
            // Targeting the first item in the primarySet to add the vertical divider line
            // using a pseudo element
            '&:first-child > div:first-child': {
                '@media (min-width: 480px)': {
                    ':after': {
                        alignSelf: 'center',
                        background: '#fff',
                        content: '""',
                        height: 24,
                        margin: '0 1%',
                        width: 1,
                    },
                },
            },
        },
        root: {
            backgroundColor: 'transparent',
            color,
            height: APPBAR_HEIGHT,
            padding: 0,
            '.ms-Button-icon, .ms-Button-menuIcon, .ms-CommandBarItem-link': {
                color: 'inherit',
            },
            '.ms-CommandBarItem-link:hover': {
                color: 'inherit',
            },
            '.ms-CommandBarItem-link:active': {
                color: palette.themePrimary,
            },
            '.ms-CommandBarItem-link:focus::after': {
                outlineColor: '#fff !important',
            },
            // Icon
            '.ms-CommandBarItem-link:hover .ms-Button-icon': {
                color: 'inherit',
            },
            '.ms-CommandBarItem-link:active .ms-Button-icon': {
                color: palette.themePrimary,
            },
            // Menu caret icon
            '.ms-CommandBarItem-link:hover .ms-Button-menuIcon': {
                color: 'inherit',
            },
            '.ms-CommandBarItem-link:active .ms-Button-menuIcon': {
                color: palette.themePrimary,
            },
            // Menu icons when expanded
            '.ms-CommandBarItem-link.is-expanded': {
                color: palette.themePrimary,
            },
            // OverflowButton Icon
            '.ms-CommandBar-overflowButton .ms-Button-menuIcon': {
                color: '#fff',
            },
            '.ms-CommandBar-overflowButton:hover .ms-Button-menuIcon': {
                color: '#fff',
            },
            '.ms-CommandBar-overflowButton.is-expanded .ms-Button-menuIcon': {
                color: palette.themePrimary,
            },
        },
    };
};
